import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { reverseGeocodeSelector } from 'selectors'
import getAddressFromLocation from 'helpers/map/getAddressFromLocation'
import { updateProjectAction } from 'actions/projectActions'
import { notifyHoneybadgerAction, reverseGeocodeLocationAction } from 'actions/applicationActions'
import { REVERSE_GEOCODE_LOCATION } from 'actions/applicationActionTypes'
import { UPDATE_CAMERA, updateCameraAction } from 'actions/cameraActions'
import { updateEntityAction } from 'actions/entityActions'
import { UPDATE_ENTITY } from 'actions/entityActionTypes'
import findById from 'helpers/findById'
import path from 'ramda/src/path'

export function * reverseGeocodeLocation(action) {
  try {
    const { location } = action
    const address = yield call(getAddressFromLocation, location)

    if (address) {
      yield put(updateProjectAction({ title: address }))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for reverse geocode location action, then call function */
export function * watchReverseGeocodeLocation() {
  yield * takeEvery(REVERSE_GEOCODE_LOCATION, reverseGeocodeLocation)
}

export function * checkIfFirstDrag(action) {
  try {
    const { id, type, key, value, updates, entityType } = action
    if (id !== 1 || (type === UPDATE_CAMERA && key !== 'location') || (type === UPDATE_ENTITY && !(['doorControllers', 'networkClosets', 'wiredDevices'].includes(entityType) && updates['location']))) return

    const { cameras, entities, titleChanged } = yield select(reverseGeocodeSelector)
    if (titleChanged) return

    const camera = findById({ id: 1, state: cameras })
    if ((camera && camera.dragged) || path([entityType, 'byId', 1, 'dragged'], entities)) return

    const location = (type === UPDATE_ENTITY && updates['location']) || (type === UPDATE_CAMERA && value)
    if (!location) return

    yield put(reverseGeocodeLocationAction(typeof location.lat === 'function' ? { lat: location.lat(), lng: location.lng() } : { lat: location.lat, lng: location.lng }))

    if (type === UPDATE_CAMERA) {
      return yield put(updateCameraAction('dragged', true, camera.id))
    } else {
      yield put(updateEntityAction(entityType, id, { dragged: true }))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for update camera action, then call function */
export function * watchUpdateCameraForDrag() {
  yield * takeEvery([UPDATE_CAMERA, UPDATE_ENTITY], checkIfFirstDrag)
}



// WEBPACK FOOTER //
// ./src/sagas/reverseGeocodeLocationSaga.js